<template>
    <div>
        <h3 v-if="template||page">{{isTemplate?template.name:page.name}}</h3>
        <div>
            <div class="yq-report-searchbar">
                <el-form inline>
                    <el-form-item label="标题">
                        <el-input v-model="searchModel.titleLike"></el-input>
                    </el-form-item>
                    <el-form-item label="期号">
                        <el-input v-model="searchModel.issueName"></el-input>
                    </el-form-item>
                    <el-form-item label="分类">
                        <el-select v-model="searchModel.category" multiple filterable allow-create default-first-option clearable>
                            <el-option v-for="item in categories" :key="item" :label="item" :value="item"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="作者">
                        <el-input v-model="searchModel.authorsLike"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary">搜索</el-button>
                        <el-button type="primary">上传报告</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="yq-report-list" v-if="data">
                <div class="yq-report-item" v-for="report in data.content" :key="report.id">
                    <div class="yq-report-item-cover-picture">
                        <div class="yq-report-item-headline">
                            <div class="yq-report-item-title">{{report.title}}</div>
                            <div class="yq-report-item-subtitle">{{report.category}}-{{report.issueName}}</div>
                            <div class="yq-report-item-authors">{{report.authors}}</div>
                        </div>
                        <div class="yq-report-item-date">
                            <pretty-date-time :value="report.createdAt" format="YYYY-MM-DD"></pretty-date-time>
                        </div>
                    </div>
                    <div class="yq-report-item-toolbar">
                        <el-button-group>
                            <el-button icon="el-icon-edit" size="mini"></el-button>
                            <el-button icon="el-icon-delete" size="mini"></el-button>
                            <el-button icon="el-icon-download" size="mini"></el-button>
                        </el-button-group>
                    </div>
                </div>
            </div>
            <div class="foot" v-if="data">
                <el-pagination
                        layout="prev, pager, next" background
                        :total="data.totalElements" :current-page="data.number+1">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import pageTemplateService from '../../service/page-template'
    import pageService from '../../service/page'

    export default {
        name: "ReportsPagePreview",
        props: ["id", "isTemplate"],
        data() {
            return {
                template: null,
                page: null,
                searchModel: {
                    titleLike: null,
                    issueName: null,
                    category: null,
                    authorsLike: null
                },
                categories: ['热点舆情'],
                data: {
                    totalElements: 3,
                    number: 0,
                    content: [
                        {
                            title: '舆情报告',
                            attachment: null,
                            coverPicture: null,
                            summary: null,
                            issueName: '第三期',
                            issueNo: 3,
                            category: '热点舆情',
                            authors: '张三',
                        },
                        {
                            title: '舆情报告',
                            attachment: null,
                            coverPicture: null,
                            summary: null,
                            issueName: '第二期',
                            issueNo: 2,
                            category: '热点舆情',
                            authors: '张三',
                        },
                        {
                            title: '舆情报告',
                            attachment: null,
                            coverPicture: null,
                            summary: null,
                            issueName: '第一期',
                            issueNo: 1,
                            category: '热点舆情',
                            authors: '张三',
                        }
                    ]
                },
            }
        },
        created(){
            if(this.isTemplate){
                pageTemplateService.getPageTemplate(this.id).then(response => {
                    this.template = response.data
                }).catch(() => {
                    this.$message({
                        type: 'error',
                        message: '请求出错!'
                    })
                })
            }else{
                pageService.getPage(this.id).then(response => {
                    this.page = response.data
                }).catch(() => {
                    this.$message({
                        type: 'error',
                        message: '请求出错!'
                    })
                })
            }
        }
    }
</script>
<style scoped>

</style>
